// extracted by mini-css-extract-plugin
export default {"heading4":"Heading4_heading4__1MwKZ"};